import { render, staticRenderFns } from "./CouponCreate.vue?vue&type=template&id=3be35902"
import script from "./CouponCreate.vue?vue&type=script&lang=js"
export * from "./CouponCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports